// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';

import { Intro } from 'src/Layout';

import { CallToAction } from './CallToAction';

import styles from './EmptyCart.scss';

export function EmptyCart(): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <div className={styles.root}>
      <Intro title={__('Your shopping cart is empty.')} />
      <CallToAction isEmptyPage />
    </div>
  );
}
